import { AlertManagementAction } from '../actions';
import { ApiCaller } from '../../config';
import { put } from 'redux-saga/effects';
import { Utils } from '../../config';

export default class AlertManagementMiddleware {
    static *GetAlerts(params) {
        const { payload } = params;
        console.log(payload);
        const { isRecent, limit, current, searchVal } = payload;
        try {
            const res = yield ApiCaller.Get(
                `/security-alerts?isRecent=${isRecent}&page=${current}&per_page=${limit}&search=${searchVal}`,
            );
            if (res.status === 200) {
                yield put(AlertManagementAction.GetAlertsSuccess(res));
            } else {
                yield put(AlertManagementAction.GetAlertsFailure());
            }
        } catch (err) {
            yield put(AlertManagementAction.GetAlertsFailure(Utils.isSubscriptionError(err)));
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }

    static *GetAlertDetail(params) {
        const { payload, cb } = params;
        const { id } = payload;
        try {
            const res = yield ApiCaller.Get(`/security-alert/${id}`);
            if (res.status === 200) {
                yield put(
                    AlertManagementAction.GetAlertDetailSuccess(res?.data),
                );
                if (cb) cb();
            } else {
                yield put(AlertManagementAction.GetAlertDetailFailure());
            }
        } catch (err) {
            yield put(AlertManagementAction.GetAlertDetailFailure());
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }

    static *AddAlert(params) {
        const { payload, cb } = params;
        try {
            const res = yield ApiCaller.Post('/security-alerts', payload);
            if (res.status === 200 || res.status === 201) {
                yield put(AlertManagementAction.AddAlertSuccess());
                if (cb) cb();
                Utils.showMessage('success', res?.data?.message);
            } else {
                yield put(AlertManagementAction.AddAlertFailure());
                Utils.showMessage('error', 'Error adding alert');
            }
        } catch (err) {
            yield put(AlertManagementAction.AddAlertFailure());
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }

    static *UpdateAlert(params) {
        const { payload, id, cb } = params;
        try {
            const res = yield ApiCaller.Put(`/security-alerts/${id}`, payload);
            if (res.status === 200 || res.status === 201) {
                yield put(AlertManagementAction.UpdateAlertSuccess());
                if (cb) cb();
                Utils.showMessage('success', res?.data?.message);
            } else {
                yield put(AlertManagementAction.UpdateAlertFailure());
                Utils.showMessage('error', 'Error updating alert');
            }
        } catch (err) {
            yield put(AlertManagementAction.UpdateAlertFailure());
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }

    static *UpdateAlertStatus(params) {
        const { payload, cb } = params;
        const { id, status } = payload;
        try {
            const res = yield ApiCaller.Patch(`/security-alerts/${id}/status`, {
                status,
            });
            if (res.status === 200) {
                yield put(AlertManagementAction.UpdateAlertStatusSuccess());
                if (cb) cb();
                Utils.showMessage('success', res?.data?.message);
            } else {
                yield put(AlertManagementAction.UpdateAlertStatusFailure());
                Utils.showMessage('error', 'Error updating alert status');
            }
        } catch (err) {
            yield put(AlertManagementAction.UpdateAlertStatusFailure());
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }
}
